import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

/**
 * withRouter HOC for React Router 6 compatibility.
 * Provides match, location, and history-like props to class components.
 */
export function withRouter(Component) {
	function WithRouterWrapper(props) {
		const params = useParams();
		const location = useLocation();
		const navigate = useNavigate();

		const match = { params };
		const history = {
			push: navigate,
			replace: (to) => navigate(to, { replace: true }),
			goBack: () => navigate(-1),
			location
		};

		return <Component {...props} match={match} location={location} history={history} />;
	}

	WithRouterWrapper.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
	return WithRouterWrapper;
}
